'use client';

import { useFormStatus } from 'react-dom';

import { Button } from '../ui/button';

export function SubmitButton({ value, className }: { value: string; className?: string }) {
  const { pending } = useFormStatus();

  return (
    <Button className={className} type='submit' aria-disabled={pending}>
      {pending ? 'Loading…' : value}
    </Button>
  );
}
